<script setup lang="ts">
import ScBtn from '@/components/common/widget/ScBtn.vue';
import { inject, onMounted, ref } from 'vue';
import { toCanvas } from 'qrcode';
import zfbIcon from '@/assets/images/zfb_icon.svg';
import { message, Modal } from 'ant-design-vue';
import { WindowTool } from '@/components/common/window/WindowInterface';
import { request } from '@/util/request';

const props = defineProps<{ qrUrl: string; order: any }>();

const windowTool = inject<WindowTool | false>(WindowTool, false);

async function check(showMsg: boolean) {
  const res = await request('/management/order/checkPayment', {
    id: props.order.id,
  });
  if (res.status === 'wait') {
    if (showMsg) {
      message.warn('未检测到支付成功');
    }
    return;
  }
  windowTool && windowTool.close();
  Modal.info({
    title: '恭喜完成支付',
  });
}

const qrRef = ref();

// const intervalHandler = setInterval(() => check(false), 5000);
//
// onUnmounted(() => clearInterval(intervalHandler));

onMounted(() => {
  toCanvas(qrRef.value, props.qrUrl, {
    width: 280,
    margin: 0,
  });
});
</script>

<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px;
      position: relative;
    "
  >
    <div style="position: absolute; left: 20px; top: 20px; z-index: 1">
      <a-image :src="zfbIcon" :preview="false" />
    </div>
    <div
      style="
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        height: 28px;
      "
    >
      <div>请使用支付宝扫码支付</div>
    </div>
    <div style="font-size: 30px">¥{{ order.price }}</div>
    <div style="padding: 10px">
      <canvas ref="qrRef" />
    </div>
    <div>
      <sc-btn
        text="已完成支付"
        type="primary"
        :handler="() => check(true)"
        style="margin-left: 16px"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.space-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.line {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.pay-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #bbb;
  padding: 10px 50px 10px 10px;
  border-radius: 4px;
}
</style>
